<template>

</template>

<script>
import VueEventBus from '../../vue-event-bus';
import { mapState, mapGetters } from 'vuex';
export default {
    name: 'rostermpexport',
        components: {
        },
    data () {
        return {
            timerIds: {},

        }
    },
    created: function () {
        VueEventBus.$on("publishToMP", this.sendMPRequest);
    }, 
    computed: {
        ...mapGetters(['storeId', 'rosterFromTo', 'storeSettings']),
    },
    beforeDestroy() {
        VueEventBus.$off("publishToMP", this.sendMPRequest);
    },
    watch: { 
    
    },
    // methods that implement data logic.
    methods: {

        sendMPRequest(data){
            let view = this;
            if(data.modal){
                window.app.popupalerts.push({header: this.$t('roster.main.publishMp'), number: null, description: this.$t('roster.main.publishMpQuery'), hidden: false,
                callbackAccept: function(popup){
                    let url = '/api/sec/export/mp';
                    let params = {
                        storeId: view.$store.state.storeId,
                    }
                
                    view.buildMPRequest()
                    .then(data => {
                        popup.loading = false;
                        popup.hidden = true;
                        view.sendMPRequestWithTimer(data, 5*1000)
                    })
                    .catch(error => {
                        console.log(error);
                        
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.main.publishMpError'));
                    })
                }, callbackCancel: function(popup){
                        popup.loading = false;
                        popup.hidden = true; 
                }});
            } else {
                let url = '/api/sec/export/mp';
                let params = {
                    storeId: view.$store.state.storeId,
                }
                
                view.buildMPRequest()
                .then(data => {
                    view.sendMPRequestWithTimer(data, 30*1000)
                })
                .catch(error => {
                    console.log(error);
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.main.publishMpError'));
                }) 
            }
            
        },
        sendMPRequestWithTimer(data, timeout) {
            let view = this;
            let storeId = view.$store.state.storeId;
            clearTimeout(this.timerIds[""+storeId]);
            this.timerIds[""+storeId] = window.setTimeout(function(){
                let url = '/api/sec/export/mp';
                let params = {
                    storeId: storeId,
                }
                view.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+view.$store.state.jwt
                    },
                    url: url,
                    data: data
                }).then(result => {  
                    view.$helpers.success(view.$t('global.notifications.success'), view.$t('roster.main.mpPublished'));
                })
                .catch(error => {
                    console.log(error);
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.main.publishMpError'));
                });
            }, timeout)
        },
        buildMPRequest(){
            let view = this;
            if(this.rosterFromTo != null && this.storeId != null){
                let employeeMap = {};
                let employeeDatePreferenceMap = {};
                let employeeDateShiftMap = {};
                let employeeIds = new Set();
                let spotMap = {};
                let businessUnitMap = {};
                return this.$helpers.GetEmployeeMap(false)
                .then(map => {
                    for(let i in map){
                        let employee = map[i];
                        if(employee.active){
                            employeeMap[employee.id] = employee;
                            employeeIds.add(employee.id);
                        }
                    }
                    return view.$helpers.GetEmployeePreferenceMap(false);
                }).then(map => {
                    Object.values(map).forEach(pref => {
                        if(pref.state == 1 && pref.approved && employeeIds.has(pref.employeeId)){
                            let from = view.$helpers.getMomentFromStringTZ(pref.from);
                            let to = view.$helpers.getMomentFromStringTZ(pref.to);
                            while(to > from){
                                if(!employeeDatePreferenceMap[pref.employeeId]){
                                    employeeDatePreferenceMap[pref.employeeId] = {};
                                }
                                if(!employeeDatePreferenceMap[pref.employeeId][from.format("YYYY-MM-DD")]){
                                    employeeDatePreferenceMap[pref.employeeId][from.format("YYYY-MM-DD")] = [];
                                }
                                employeeDatePreferenceMap[pref.employeeId][from.format("YYYY-MM-DD")].push(pref);
                                from = from.add(1, 'days');
                            }
                            
                        }  
                    });
                    return view.$helpers.GetPlanShiftMap(false);    
                }).then(map => {
                    Object.values(map).forEach(shift => {
                        if(shift.published && shift.employeeId != null){
                            let from = view.$helpers.getMomentFromStringTZ(shift.from);
                            if(!employeeDateShiftMap[shift.employeeId]){
                                employeeDateShiftMap[shift.employeeId] = {};
                            }
                            if(!employeeDateShiftMap[shift.employeeId][from.format("YYYY-MM-DD")]){
                                employeeDateShiftMap[shift.employeeId][from.format("YYYY-MM-DD")] = [];
                            }
                            employeeDateShiftMap[shift.employeeId][from.format("YYYY-MM-DD")].push(shift);
                        }  
                    });
                    return view.$helpers.GetSpotMap(false);    
                }).then(map => {
                    spotMap = map;
                    return view.$helpers.GetBusinessUnitMap(false); 
                    
                }).then(map => {
                    businessUnitMap = map;
                    let result = view.buildMPRequestWithData(employeeMap, employeeDateShiftMap, employeeDatePreferenceMap, spotMap, businessUnitMap);
                    return new Promise((resolve, reject) => {
                        resolve(result);
                    });
                }).catch(error => {
                    return new Promise((resolve, reject) => {
                        reject(error);
                    });
                })
            } else {
                return new Promise((resolve, reject) => {
                    reject("Not ready!");
                });
            }
        },
        sortEmployeesByName(a, b) {
            let result = (a.lastName > b.lastName) ? 1 : ((b.lastName > a.lastName) ? -1 : 0);
           return  result;
        },
        sortEmployeesBySpots(a, b, spotA, spotB){
            if(spotA.unitId == spotB.unitId && (spotA.isMain || spotB.isMain) && spotA.id != spotB.id){
                if(spotA.isMain){
                    return 1;
                } else {
                    return -1;
                }
            } 
            if(spotA.priority == spotB.priority){
                if(spotA.name == spotB.name){
                    return this.sortEmployeesByName(a, b);
                } else {
                    return (spotA.name < spotB.name) ? -1 : 1
                }
            } else {
                return (spotA.priority < spotB.priority) ? -1 : 1
            } 
        },
        sortEmployeesByUnits(a, b, unitA, unitB, spotA, spotB){
            if(unitA.priority == unitB.priority){
                if(unitA.name == unitB.name){
                    return this.sortEmployeesBySpots(a, b, spotA, spotB);
                } else {
                    return (unitA.name < unitB.name) ? -1 : 1
                }
            } else {
                return (unitA.priority < unitB.priority) ? -1 : 1
            }
        },
        sortEmployees(a, b, businessUnitMap, spotMap){
            let spotA = spotMap[a.spotId];
            let spotB = spotMap[b.spotId];
            if(spotA == null && spotB == null){
                return this.sortEmployeesByName(a, b);
            } else if(spotA == null) {
                return 1
            } else if(spotB == null) {
                return -1
            } else {
                let unitA = businessUnitMap[spotA.unitId];
                let unitB = businessUnitMap[spotB.unitId];
                if(unitA == null && unitB == null){
                    return this.sortEmployeesBySpots(a, b, spotA, spotB);
                } else if(unitA == null) {
                    return 1
                } else if(unitB == null) {
                    return -1
                } else {
                    return this.sortEmployeesByUnits(a, b, unitA, unitB, spotA, spotB);
                }
            }
        },
        buildMPRequestWithData(employeeMap, employeeDateShiftMap, employeeDatePreferenceMap, spotMap, businessUnitMap){
            let lines = [];
            let ordering = 0;
            let view = this;
            let employees = Object.values(employeeMap).sort((a,b) => view.sortEmployees(a, b, businessUnitMap, spotMap));
            employees.filter(e => (spotMap[e.spotId] && spotMap[e.spotId].employeeLevel <= view.storeSettings.maxEmployeeLevelToMp && spotMap[e.spotId].exportToMp) || e.spotId == null).forEach(employee => {
                let line = {
                    value1: employee.firstName,
                    value2: employee.lastName,
                    font1: "Roboto-Condensed",
                    font2: "Roboto-Condensed",
                    color: "rgba(0, 0, 0, 1)",
                    lineColor: "rgba(255,255,255,1)",
                    ordering: ordering,
                    fields: [],
                }
                let startOfMonth = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1);
                let endOfMonth = startOfMonth.clone().endOf('month').add(1,'days').startOf('month');
                while(endOfMonth > startOfMonth){
                    let shifts = [];
                    let key = startOfMonth.format("YYYY-MM-DD");
                    if(employeeDateShiftMap[employee.id] && employeeDateShiftMap[employee.id][key]){
                        shifts = employeeDateShiftMap[employee.id][key];
                        if(shifts.length > 0){
                            shifts = shifts.filter(s => (spotMap[s.spotId] && spotMap[s.spotId].exportToMp) || s.spotId == null);
                        }
                    }
                    let value1 = "X";
                    let value2 = null;
                    let font1 = "Roboto-Condensed";
                    let font2 = null;
                    let middleLineColor = null;
                    if(shifts.length > 0){
                        let minShift = shifts.reduce((prev, curr) => {
                            let prevFrom = view.$helpers.getMomentFromStringTZ(prev.from);
                            let currFrom = view.$helpers.getMomentFromStringTZ(curr.from);
                            let result = prevFrom < currFrom ? prev : curr;
                            return result;
                        });
                        let maxShift = shifts.reduce((prev, curr) => {
                            let prevTo = view.$helpers.getMomentFromStringTZ(prev.from);
                            let currTo = view.$helpers.getMomentFromStringTZ(curr.from);
                            let result = prevTo > currTo ? prev : curr;
                            return result;
                        });
                        value1 = view.$helpers.getMomentFromStringTZ(minShift.from).format("HH:mm");
                        value2 = view.$helpers.getMomentFromStringTZ(maxShift.to).format("HH:mm");
                        let spot = spotMap[minShift.spotId];
                        let rgb = view.hexToRGB(spot.color);
                        middleLineColor = "rgba("+rgb[0]+","+rgb[1]+","+rgb[2]+",1)";
                        font2 = "Roboto-Condensed";
                    } else if(this.storeSettings.country == 1){
                        let prefs = [];
                        if(employeeDatePreferenceMap[employee.id] && employeeDatePreferenceMap[employee.id][key]){
                            prefs = employeeDatePreferenceMap[employee.id][key]
                        }  
                        if(prefs.length > 0 && prefs[0].state == 1  && prefs[0].approved){
                            if(prefs[0].type == 1 || prefs[0].type == 6){
                                value1 = "U";
                            } else {
                                value1 = "X";
                            }
                        } 
                    }
                    line.fields.push({
                        day: startOfMonth.date(),
                        value1: value1,
                        value2: value2,
                        font1: font1,
                        font2: font2,
                        color: "rgba(0,0,0,1)",
                        middleLineColor: middleLineColor,
                        backgroundColor: null,
                    })
                    startOfMonth = startOfMonth.add(1,'days');
                }
                lines.push(line);
                ordering++;
            });
            let result =  {
                store_id: this.storeId,
                player_id: null,
                month: this.rosterFromTo.month+1,
                year: this.rosterFromTo.year,
                language: "de",
                lines: lines,
            }
            console.log(result);
            return result;
        },
        hexToRGB(hex){
            return hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i
             ,(m, r, g, b) => '#' + r + r + g + g + b + b)
            .substring(1).match(/.{2}/g)
            .map(x => parseInt(x, 16));
        }
    },
}
</script>

<!-- Add "scoped" attrispotte to limit CSS to this component only -->
<style>
    
</style>
